module.exports = __webpack_public_path__ + "static/Hitbtc-ef68df9fb264c9d3053bb6e9de6280ad.png";